// Hubita Design Token System — Figma Facelift
// Primary brand color: #6C2BD9 (purple)
// Background: #F5F7FB | Surface: #FFFFFF | Sidebar: #FFFFFF (white)

export const COLORS = {
  // Brand
  primary: '#6C2BD9',
  primaryLight: '#F0E8FF',
  primaryDark: '#5420B3',
  primaryHover: '#7B35E8',

  // Background
  appBg: '#F5F7FB',
  surface: '#FFFFFF',
  surfaceHover: '#F8F9FC',

  // Sidebar
  sidebarBg: '#FFFFFF',
  sidebarActiveBg: '#6C2BD9',
  sidebarActiveText: '#FFFFFF',
  sidebarInactiveText: '#6B7280',
  sidebarIconInactive: '#9CA3AF',
  sidebarBorder: '#F3F4F6',

  // Text
  textPrimary: '#111827',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
  textWhite: '#FFFFFF',
  textLink: '#6C2BD9',

  // Status
  success: '#10B981',
  successLight: '#D1FAE5',
  warning: '#F59E0B',
  warningLight: '#FEF3C7',
  danger: '#EF4444',
  dangerLight: '#FEE2E2',
  info: '#3B82F6',
  infoLight: '#DBEAFE',

  // Priority badges
  highBg: '#FEE2E2',
  highText: '#DC2626',
  mediumBg: '#FEF3C7',
  mediumText: '#D97706',
  lowBg: '#D1FAE5',
  lowText: '#059669',

  // Border
  border: '#E5E7EB',
  borderLight: '#F3F4F6',
  divider: '#F3F4F6',

  // UI elements
  cardBg: '#FFFFFF',
  inputBg: '#F9FAFB',
  inputBorder: '#D1D5DB',
  inputBorderFocus: '#6C2BD9',
  placeholderBg: '#F0E8FF',

  // Charts
  chartPurple: '#6C2BD9',
  chartGreen: '#10B981',
  chartRed: '#EF4444',
  chartOrange: '#F59E0B',
  chartBlue: '#3B82F6',

  // Legacy (keep for backward compat)
  purple: '#6D08C0',
  lightPurple: 'rgb(160, 112, 196)',
  gradientColor1: '#7002BC',
};

export const TYPOGRAPHY = {
  fontFamily: {
    regular: 'roboto-light',
    medium: 'roboto-light',
    semiBold: 'roboto-light',
    bold: 'roboto-light',
  },
  fontSize: {
    xs: 11,
    sm: 12,
    base: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 28,
    '4xl': 32,
  },
  fontWeight: {
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
    extraBold: '800',
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
  },
};

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  '2xl': 32,
  '3xl': 40,
  '4xl': 48,
  '5xl': 64,
};

export const BORDER_RADIUS = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  '2xl': 20,
  full: 9999,
};

export const SHADOWS = {
  sm: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.10,
    shadowRadius: 16,
    elevation: 6,
  },
  card: {
    shadowColor: '#6C2BD9',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 2,
  },
};

export const LAYOUT = {
  sidebarWidth: 220,
  sidebarWidthTab: 72,
  topBarHeight: 64,
  mobileTopBarHeight: 56,
  bottomTabHeight: 64,
  maxContentWidth: 1200,
  cardPadding: 16,
};

export default {
  COLORS,
  TYPOGRAPHY,
  SPACING,
  BORDER_RADIUS,
  SHADOWS,
  LAYOUT,
};
